/* Free gift prompt for the cart drawer and cart page. Added 4 Nov 2026 (Claude, for Karl).
   Fetches sections/free-gift-prompt.liquid and shows it above the cart total.
   Only adds a gift when the shopper presses "Add free"; never adds anything on its own. */
(function () {
  if (window.freeGiftPromptLoaded) return;
  window.freeGiftPromptLoaded = true;

  var cfg = window.freeGiftPromptConfig || { root: '/', addUrl: '/cart/add.js' };
  var root = cfg.root.replace(/\/?$/, '/');
  var html = '';
  var timer = null;
  var busy = false;

  function onCartPage() { return /\/cart\/?$/.test(window.location.pathname); }

  function targets() {
    var list = [];
    var drawerFooter = document.querySelector('#CartDrawer .drawer__footer');
    if (drawerFooter) list.push({ parent: drawerFooter, id: 'FreeGiftPrompt-Drawer' });
    var pageBlocks = document.querySelector('#main-cart-footer .cart__blocks');
    if (pageBlocks) list.push({ parent: pageBlocks, id: 'FreeGiftPrompt-Page' });
    return list;
  }

  function place() {
    targets().forEach(function (t) {
      var box = document.getElementById(t.id);
      if (!box) {
        box = document.createElement('div');
        box.id = t.id;
        box.className = 'free-gift-prompt-slot';
        t.parent.insertBefore(box, t.parent.firstChild);
      }
      if (box.innerHTML !== html) box.innerHTML = html;
    });
  }

  function refresh() {
    if (busy) return;
    busy = true;
    fetch(root + '?section_id=free-gift-prompt', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var el = doc.querySelector('.shopify-section') || doc.body;
        html = el ? el.innerHTML.trim() : '';
        place();
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function soon() { clearTimeout(timer); timer = setTimeout(refresh, 200); }

  // The theme replaces the drawer / cart footer HTML whenever the cart changes. Re-place and refresh then.
  function watch() {
    var nodes = [document.querySelector('cart-drawer'), document.getElementById('main-cart-footer')];
    var mo = new MutationObserver(function (muts) {
      var ours = muts.every(function (m) {
        return m.target.closest && m.target.closest('.free-gift-prompt-slot');
      });
      if (!ours) soon();
    });
    nodes.forEach(function (n) { if (n) mo.observe(n, { childList: true, subtree: true }); });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, soon);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-free-gift-add]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('.free-gift-prompt');
    var err = box && box.querySelector('.free-gift-prompt__error');
    var variantId = Number(btn.getAttribute('data-free-gift-add'));
    var drawer = document.querySelector('cart-drawer');
    var useDrawer = !onCartPage() && drawer && typeof drawer.renderContents === 'function';
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (useDrawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }
    fetch(cfg.addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (res) {
        if (useDrawer && res.sections) {
          res.id = variantId;
          drawer.renderContents(res);
          soon();
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add free';
        if (err) err.hidden = false;
      });
  });

  function start() { watch(); refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
